import React, { useState, useRef, useEffect } from "react";
import { Redirect, Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import JqxListBox from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxlistbox';
import {Form, Row, Col} from "react-bootstrap"
import ClientHeader from "../components/Profile/ClientHeader";
import { useGetProfiles, useGetRoles, useGetClients, useGetClientPermissionsTableSchema } from "../hooks/useOfManageUserPermission";
import ClientService from '../services/client.service'
import { DirectionalHint, TooltipHost } from '@fluentui/react';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import List from '../components/Controls/List';
import PropTypes from 'prop-types';
import AuthVerify from "../components/AuthVerify";

import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css"
import { __ProfileName } from "../common/Dictionaries";

function ManagePermissions(props) {

    const { t } = useTranslation();

    const clientId = props.location.state !== null ? props.location.state.clientId : null;
    const { user: currentAuth } = useSelector((state) => state.auth);

    const [sourceClientList, setSourceClientList] = useState(null);
    const [sourceProfileList, setSourceProfileList] = useState(null);
    useGetProfiles(sourceProfileList, setSourceProfileList);
    const [sourceRoleList, setSourceRoleList] = useState(null);
    useGetRoles(sourceRoleList, setSourceRoleList, false);
    const [sourceUserList, setSourceUserList] = useState([]);
    const [sourceProductList, setSourceProductList] = useState([]);
    const sourceContractsList = [];
    
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedContracts, setSelectedContracts] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [selectedProfileLabel, setSelectedProfileLabel] = useState(null);
    const [selectedRoles, setSelectedRoles] = useState([]);

    const [showDependentListBox, setShowDependentListBox] = useState(true);
    
    const [clientPermissionsDataTableSchema, setClientPermissionsDataTableSchema] = useState({data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetClientPermissionsTableSchema(clientPermissionsDataTableSchema, setClientPermissionsDataTableSchema, clientId);


    const onRenderItemStyles = { root: { padding: '10px' } };
    const onRenderOverflowButtonStyles = { root: { padding: '10px' }, menuIcon: { fontSize: '16px' } };

    const onRenderOverflowButton = (overflowItems) => {
        return (
          <TooltipHost content="More items" directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
              role="menuitem"
              aria-label="More items"
              styles={onRenderOverflowButtonStyles}
              menuIconProps={{ iconName: 'More' }}
              menuProps={{ items: overflowItems }}
            />
          </TooltipHost>
        );
    };
    const onRenderItem = (item) => {
        return (
          <TooltipHost content={item.title} directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
              role="menuitem"
              aria-label={item.name}
              styles={onRenderItemStyles}
              iconProps={{ iconName: item.icon }}
              onClick={item.onClick}
            />
          </TooltipHost>
        );
    };

    const jqxListUsers = useRef();
    const jqxListProduct = useRef();
    const jqxListContracts = useRef();
    const jqxListProfiles = useRef();
    const jqxListRoles = useRef();
    const btnAssign = useRef();

    useEffect(()=> {
        if (clientId !== null) {
            setSelectedClient(clientId);
            getSourceUsers(clientId);
            getSourceProducts(clientId);
        }
    }, [clientId]);

    useGetClients(sourceClientList, setSourceClientList);
    
    const loadConnectedData = (e) => {
        const clientid = e;

        setSelectedClient(clientid);
        getSourceUsers(clientid);
        getSourceProducts(clientid);
        getDataAndSchema(clientid);
    }

    const clearFilters = () => {
        UnselectItems(jqxListUsers);
        UnselectItems(jqxListProduct);
        UnselectItems(jqxListContracts);
        UnselectItems(jqxListProfiles);
        UnselectItems(jqxListRoles);

        setSelectedUsers([]);
        setSelectedProducts([]);
        setSelectedContracts([]);
        setSelectedProfile(null);
        setSelectedProfileLabel(null);
        setSelectedRoles([]);

        enableAssignButton();
    }

    const UnselectItems = (objJqxList) => {
        if (objJqxList.current !== null) {
            const objJqxListSelectedItems = objJqxList.current.getSelectedItems();

            for (let element of objJqxListSelectedItems) {
                objJqxList.current.unselectItem(element);
            }
        }
    }

    const getDataAndSchema = async (clientid) => {

        let serviceResponse = await ClientService.getAllPermissions(clientid);
        const response = serviceResponse.data;

        const source = {
            dataType: 'array',
            localdata: response.data
        };
        
        setClientPermissionsDataTableSchema(source);
    }
    
    //Obtiene los usuarios segun el cliente seleccionado.
    const getSourceUsers = async (clientId) => {
        try {
            let serviceResponse = await ClientService.getAllUsers(clientId);
            const response = serviceResponse.data;
            setSourceUserList(response)
        }
        catch (error) {
        }
    }

    const getSourceProducts = async (clientId) => {
        try {
            let serviceResponse = await ClientService.getAllProducts(clientId);
            const response = serviceResponse.data;
            setSourceProductList(response)
        }
        catch (error) {
        }
    }

    const onClientListBoxSelect = (e) => {
        loadConnectedData(e.args.item.value);
        enableAssignButton();
    };

    const onProfileListBoxSelect = (e) => {
        setSelectedProfile(e.args.item.value);
        setSelectedProfileLabel(e.args.item.label);

        setShowDependentListBox(e.args.item.label !== __ProfileName.Admin);
        enableAssignButton();
    };

    const onRoleListBoxSelect = (e) => {
        const updatedSelectedRolesArray = [...selectedRoles, e.args.item.value];
        setSelectedRoles(updatedSelectedRolesArray);
        enableAssignButton();
    };
    const onRolesListBoxUnselect = (e) => {
        let array = [...selectedRoles]; // make a separate copy of the array
        let index = array.indexOf(e.args.item.value);

        if (index !== -1) {
            array.splice(index, 1);
            setSelectedRoles(array);
        }
        enableAssignButton();
    }

    const onUsersListBoxSelect = (e) => {
        const updatedSelectedUsersArray = [...selectedUsers, e.args.item.value];
        setSelectedUsers(updatedSelectedUsersArray);
        enableAssignButton();
    };
    const onUsersListBoxUnselect = (e) => {
        let array = [...selectedUsers]; // make a separate copy of the array
        let index = array.indexOf(e.args.item.value);

        if (index !== -1) {
            array.splice(index, 1);
            setSelectedUsers(array);
        }
        enableAssignButton();
    }


    const onProductsListBoxSelect = (e) => {
        const updatedSelectedProductArray = [...selectedProducts, e.args.item.value];
        setSelectedProducts(updatedSelectedProductArray);
        enableAssignButton();
    };
    const onProductsListBoxUnselect = (e) => {
        let array = [...selectedProducts];
        let index = array.indexOf(e.args.item.value);

        if (index !== -1) {
            array.splice(index, 1);
            setSelectedProducts(array);
        }
        enableAssignButton();
    }


    const onContractsListBoxSelect = (e) => {
        const updatedSelectedContractArray = [...selectedContracts, e.args.item.value];
        setSelectedContracts(updatedSelectedContractArray);
        enableAssignButton();
    };
    const onContractsListBoxUnselect = (e) => {
        let array = [...selectedContracts];
        let index = array.indexOf(e.args.item.value);

        if (index !== -1) {
            array.splice(index, 1);
            setSelectedContracts(array);
        }
        enableAssignButton();
    }

    const enableAssignButton = () => {
        if (selectedProfile) {
            if (selectedProfileLabel === "Admin") {
                return (selectedClient && selectedProducts.length > 0 && selectedUsers.length > 0) ? "" : "disabled"
            }
            else {
                return (selectedClient && selectedProfile && selectedProducts.length > 0 && /*selectedContracts.length > 0 &&*/ selectedRoles.length > 0 && selectedUsers.length > 0)?
                "" : "disabled"
            }
        }
    }

    const handleAssign = (e) => {
        const objPermission = {
            listUserName: selectedUsers,
            listRoles: selectedRoles,
            profileId: selectedProfile,
            listProduct: selectedProducts,
            listNemoContract: "",//selectedContracts,
            clientId: selectedClient,
        }

        ClientService.addPermission(objPermission).then(() => {
            clearFilters();
            getDataAndSchema(selectedClient);
        }).catch((ex) => {

        });
    }

    const handleRemove = (userRoleId, clientId) => {  
        ClientService.removePermission(userRoleId, clientId).then((serviceResponse) => {
            const response = serviceResponse.data;
            if (response.succeeded === true) {

                clearFilters();

                getDataAndSchema(selectedClient)
            } else {
                //Error.
            }
        });
    };

    const handleExport = (handleDownload, listField) => {  
        ClientService.getAllPermissionsExportExcel(clientId, listField, clientPermissionsDataTableSchema).then((serviceResponse) => {
            handleDownload(serviceResponse.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,");
        });
    };

    const renderActionColumn = (item) => {
        return  <div>
                    <OverflowSet
                        className="action-menu-list-toolbar d-flex justify-content-center"
                        role="menubar"      
                        items={[
                            {
                                key: 'item1',
                                icon: 'Delete',
                                name: t('data-lang-btn-remove'),
                                title: t('data-lang-btn-remove'),
                                onClick: () => handleRemove(item.userRoleId, clientId),
                            }
                        ]}
                        onRenderOverflowButton={onRenderOverflowButton}
                        onRenderItem={onRenderItem}
                    />
                </div>
    }

    const _columns = [
        {
            key: 'UserName',
            name: t('data-lang-lbl-username'),
            fieldName: 'userName',
            minWidth: 150,
            maxWidth: 400,
        },
        {  
            key: 'ProductName',
            name: t('data-lang-lbl-product'),
            fieldName: 'productName',
            minWidth: 100,
            maxWidth: 450,
        },
        {  
            key: 'AuthRoleName',
            name: t('data-lang-lbl-profile'),
            fieldName: 'authRoleName',
            minWidth: 100,
            maxWidth: 450,
        },
        {  
            key: 'SG3RoleName',
            name: t('data-lang-lbl-role'),
            fieldName: 'sG3RoleName',
            minWidth: 100,
            maxWidth: 450,
        },
        {  
            key: 'NemoContract',
            name: t('data-lang-lbl-contract'),
            fieldName: 'nemoContract',
            minWidth: 100,
            maxWidth: 450,
        },     
        {  
            key: 'id',
            name: t('data-lang-lbl-actions'),
            fieldName: 'userRoleId',
            minWidth: 110,
            maxWidth: 110,
            onRender:(item) => renderActionColumn(item)
        }
    ];

    if (!currentAuth.profile.includes("sAdmin") || !currentAuth.profile.includes("Admin")) {
        return <Redirect to="/login" />;
    }

    return (
        <div>
            <AuthVerify currentToken={currentAuth} />
            {clientId &&
                <Row>
                <Col sm={12} md={12} lg={12} xl={12}>
                    <ClientHeader clientId={ clientId } showEditProfile={true} showManageSecurity={false} />
                </Col>
                </Row>   
            }
            <Row className="mt-5">
                {!clientId && 
                    <Form.Group as={Col}>
                        <h5>{t('data-lang-lbl-clients')}</h5>
                        <JqxListBox onSelect={onClientListBoxSelect}  filterPlaceHolder={t('data-lang-lbl-selectclient')}
                            width={'100%'} height={'200px'} source={sourceClientList}  filterable={true}
                            displayMember={'name'} valueMember={'id'} />
                    </Form.Group>
                } 
                
                <Form.Group as={Col}>
                    <h5>{t('data-lang-lbl-products')}</h5>
                        <JqxListBox ref={jqxListProduct} onSelect={onProductsListBoxSelect} onUnselect={onProductsListBoxUnselect} filterPlaceHolder={t('data-lang-lbl-selectproducts')}
                            width={'100%'} height={'200px'} source={sourceProductList}  filterable={true} multiple={true}
                            displayMember={'name'} valueMember={'productId'} /> 
                </Form.Group>

                <Form.Group as={Col}>
                    <h5>{t('data-lang-lbl-users')}</h5>
                        <JqxListBox ref={jqxListUsers} onSelect={onUsersListBoxSelect} onUnselect={onUsersListBoxUnselect} filterPlaceHolder={t('data-lang-lbl-selectusers')}
                            width={'100%'} height={'200px'} source={sourceUserList} filterable={true} multiple={true} 
                            displayMember={'username'} valueMember={'id'} />
                </Form.Group>
            </Row>
            <Row className="mt-5">
                <Form.Group as={Col}>
                    <h5>{t('data-lang-lbl-profiles')}</h5>
                    <JqxListBox ref={jqxListProfiles} onSelect={onProfileListBoxSelect} filterPlaceHolder={t('data-lang-lbl-selectprofile')}
                        width={'100%'} height={'200px'} source={sourceProfileList} filterable={true}
                        displayMember={'name'} valueMember={'id'} />
                </Form.Group>
                {
                    showDependentListBox && false &&
                    <>
                        <Form.Group as={Col}>
                            <h5>{t('data-lang-lbl-roles')}</h5>
                                <JqxListBox ref={jqxListRoles} onSelect={onRoleListBoxSelect} onUnselect={onRolesListBoxUnselect} filterPlaceHolder={t('data-lang-lbl-selectroles')}
                                    width={'100%'} height={'200px'} source={sourceRoleList} filterable={true} multiple={true} 
                                    displayMember={'nombre'} valueMember={'id'} />
                        </Form.Group>
                        {
                            false &&
                            <Form.Group as={Col}>
                                <h5>{t('data-lang-lbl-contracts')}</h5>
                                    <JqxListBox ref={jqxListContracts} onSelect={onContractsListBoxSelect} onUnselect={onContractsListBoxUnselect} filterPlaceHolder={t('data-lang-lbl-selectcontracts')}
                                        width={'100%'} height={'200px'} source={sourceContractsList} filterable={true} multiple={true} 
                                        displayMember={'nombre'} valueMember={'nemo'} />
                            </Form.Group>
                        }
                    </>
                }
            </Row>
            <Row className="mt-5">
                <h3>{t('data-lang-lbl-permissionsassigned')}</h3>
                <div className="col-12">
                    <List
                        setData={setClientPermissionsDataTableSchema}
                        data={clientPermissionsDataTableSchema}
                        columns={_columns}
                        handleExport={handleExport}
                        enableExport={true}
                        exportFileName={t('data-lang-pagename-managepermissions')}/>
                </div>
            </Row>
            <Row>
                <Form.Group className="text-end" as={Col}>
                    <button ref={btnAssign} onClick={handleAssign}
                        disabled={enableAssignButton()}
                        className="btn btn-primary btn-block col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-2 m-2">
                            {t('data-lang-btn-assing')}
                    </button>
                    <Link to="/profile">
                        <button className="btn btn-primary btn-block col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-2 m-2">{t('data-lang-btn-gohome')}</button>
                    </Link>
                </Form.Group>
            </Row>
        </div>
    );
}
ManagePermissions.propTypes = {
    location: PropTypes.object.isRequired,
};
export default ManagePermissions